export default "__VITE_ASSET__GHYrFIdv__"